<!-- <div id="appHeader">
  <nav class="navbar navbar-expand-lg navbar-dark navbar-absolute px-lg-3 px-md-3 px-sm-3">
    <a class="navbar-brand " routerLink="/">
      <img src="./assets/img/logo_small.png" class="d-inline-block align-middle img-fluid w-25 ms-4 me-2"
        alt="brand_logo" />
      TILA Top up
    </a>
    
  </nav>
</div> -->
<app-header [showTopbar]="false"></app-header>
<div class="container-fluid">
  <div class="session-activity-container">
    <div class="row justify-content-center align-items-center">
      <div class="col-xxl-4 col-lg-5 col-md-6 col-xs-12 align-self-center">
        <div class="login-blk">
          <mat-card class="p-4">
            <h4 class="form-title text-center  mb-0" translate>pages.login.login
            </h4>
            <form [formGroup]="loginForm" (submit)="submit()">
              <div class="content-details-blk px-0">
                <h4 class="form-item-label  mt-4" translate>
                  pages.login.enterUsername <span class="required">*</span>
                </h4>
                <div class="form-item-input">
                  <mat-form-field appearance="outline" class="w-100 mb-2">
                    <!-- <mat-label> <span translate class="translate">pages.login.enterUsername</span> *</mat-label> -->
                    <input matInput formControlName="userName" aria-label="Number"
                      placeholder="{{'pages.login.enterUsername' | translate}}" />
                    <angular-popper class="user-name-popper" *ngIf="
                                            loginForm.controls.userName.touched &&
                                            loginForm.controls.userName.invalid
                                          " placement="right">
                      <p class="mb-0" content *ngIf="loginForm.controls.userName.errors.required">
                        <span translate class="translate">pages.login.usernameRequired</span>
                      </p>
                    </angular-popper>
                  </mat-form-field>
                </div>
              </div>
              <div class="content-details-blk px-0">
                <h4 class="form-item-label mt-2 " translate>
                  pages.login.enterPassword <span class="required">*</span>
                </h4>
                <div class="form-item-input">
                  <mat-form-field appearance="outline" class="w-100">
                    <input matInput formControlName="password" [type]="hide ? 'password' : 'text'"
                      placeholder="{{ 'pages.login.enterPassword' | translate }}" autocomplete="new-password" />
                    <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                      [attr.aria-pressed]="hide" type="button">
                      <mat-icon class="visibility">{{
                        hide ? "visibility_off" : "visibility"
                        }}</mat-icon>
                    </button>
                    <angular-popper class="password-popper" *ngIf="
                        loginForm.controls.password.touched &&
                        loginForm.controls.password.invalid
                      " placement="right">
                      <mat-error class="target-block border-0 d-inline w-100" *ngIf="
                          loginForm.controls.password.touched &&
                          loginForm.controls.password.invalid
                        ">
                      </mat-error>
                      <p class="mb-0" content *ngIf="loginForm.controls.password.errors.required">
                        <span translate class="translate">pages.login.passwordRequired</span>
                      </p>
                    </angular-popper>
                  </mat-form-field>
                  <b>
                    <a class="py-3 text-underline text-main" routerLink="/forgot-password"
                      translate>pages.login.forgotPassword</a>
                    <mat-checkbox class="float-end" color="primary" [formControl]="rememberMeCtrl"
                      (change)="onRememberClick($event)"><span class="text-main" translate>pages.login.rememberMe</span>
                    </mat-checkbox>
                  </b>
                </div>
              </div>
              <div class="form-item-input">
                <ul class="list-inline mb-0">
                  <li class="list-inline-item">
                    <span translate class="text-main me-1">pages.login.receiveCode</span>
                    <mat-radio-group [formControl]="receiveCode">
                      <mat-radio-button color="primary" value="sms">
                        <span class="text-main" translate>pages.login.text</span>
                      </mat-radio-button>
                      <mat-radio-button color="primary" value="email">
                        <span class="text-main" translate>pages.login.email</span>
                      </mat-radio-button>
                    </mat-radio-group>

                  </li>
                </ul>
              </div>
              <div class="form-item-input">
                <ul class="list-unstyled">
                  <!-- <li>
                    <mat-checkbox
                      color="primary"
                      required
                      formControlName="isAgreed"
                      (change)="onCheckboxChange($event)"
                    >
                      <ul class="list-inline">
                        <li class="list-inline-item" translate>
                          pages.login.agreeTermsconditions
                        </li>
                        <li class="list-inline-item">
                          <angular-popper *ngIf="!popAgree" placement="right">
                            <span class="target-block border-0 d-inline">
                              <span
                                class="text-white d-inline-block pop-sperator"
                              ></span>
                            </span>

                            <p content >
                              <span translate class="translate">pages.login.pleaseagreeTermsconditions</span>
                            </p>
                          </angular-popper>
                        </li>
                      </ul>
                    </mat-checkbox>
                  </li> -->
                  <li>
                    <!--<p class="desc text-normal" translate>pages.login.loginHintTermsConditions</p>-->
                    <p class="desc text-normal fontsize-12" translate>
                      pages.login.loginHint
                      <a class="py-3 text-underline fontsize-12 text-main" (click)="openDialog()"
                        translate>pages.sidebar.termsConditions</a>
                    </p>
                  </li>
                </ul>
              </div>
              <button mat-raised-button color="primary" type="submit" class="d-block mx-auto py-2 w-100">
                <span translate class="translate"> pages.login.logIn </span>
              </button>

              <p class="desc text-normal px-0 pt-2">
                <span translate>pages.LoginPage.HavingTroubleLoggingIn</span>&nbsp; <span
                  translate>pages.LoginPage.ContactUs </span>
                :
                <a href="tel:+18886162110">
                  (888-616-2110)</a>
              </p>
            </form>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>